import AxiosInstance from "../components/Axios"
import { TaskTemplate } from "../interfaces/task_template_types"

export async function getAllTaskTemplates(): Promise<TaskTemplate[]> {
    const response = await AxiosInstance.get("api/task_template/all")
    return response.data
}

export async function createTaskTemplate(taskTemplate: TaskTemplate): Promise<TaskTemplate> {
    const response = await AxiosInstance.post("api/task_template/create", taskTemplate)
    return response.data
}

export async function updateTaskTemplate(taskTemplate: TaskTemplate): Promise<TaskTemplate> {
    const response = await AxiosInstance.put(`api/task_template/update/${taskTemplate.id}`, taskTemplate)
    return response.data
}